import React from 'react';
import { PageHero } from '../components/PageHero';
import { Button } from '../components/ui/Button';
import { navigate, BOOKING_URL } from '../lib/navigation';
import { Brain, Users, Video, BookOpen, ArrowRight, Receipt, DollarSign } from 'lucide-react';
export function Services() {
  return <div className="animate-fade-in-up" data-id="element-756">
      <PageHero title="Services" subtitle="Evidence-based support tailored to your unique journey." data-id="element-757" />

      <section className="py-20 bg-white" data-id="element-758">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-759">
          {/* Main Service: Individual Therapy */}
          <div className="bg-neutral-soft rounded-3xl p-8 md:p-12 mb-20 border border-sage/20 shadow-sm" data-id="element-760">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-761">
              <div data-id="element-762">
                <h2 className="text-3xl md:text-4xl font-medium text-teal mb-6" data-id="element-763">
                  Individual Therapy
                </h2>
                <p className="text-lg text-teal/80 mb-8 leading-relaxed" data-id="element-764">
                  One-on-one sessions where we dive deep into what's holding you
                  back. We'll use evidence-based approaches like CBT, DBT,
                  mindfulness, and narrative therapy to help you build a life
                  that feels authentic.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6" data-id="element-765">
                  <div className="flex items-center text-teal/80" data-id="element-766">
                    <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mr-4 shadow-sm text-terracotta" data-id="element-767">
                      <Video className="w-5 h-5" data-id="element-768" />
                    </div>
                    <div data-id="element-769">
                      <p className="font-semibold text-teal" data-id="element-770">Online</p>
                      <p className="text-sm" data-id="element-771">Across Ontario</p>
                    </div>
                  </div>
                  <div className="flex items-center text-teal/80" data-id="element-772">
                    <div className="w-10 h-10 bg-white rounded-full flex items-center justify-center mr-4 shadow-sm text-terracotta" data-id="element-773">
                      <Brain className="w-5 h-5" data-id="element-774" />
                    </div>
                    <div data-id="element-775">
                      <p className="font-semibold text-teal" data-id="element-776">50 Minutes</p>
                      <p className="text-sm" data-id="element-777">$130 per session</p>
                    </div>
                  </div>
                </div>

                {/* Insurance note */}
                <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-sage/15 mb-4" data-id="element-778">
                  <Receipt className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-779" />
                  <p className="text-sm text-teal/80" data-id="element-780">
                    <span className="font-medium text-teal" data-id="element-781">
                      Insurance accepted.
                    </span>{' '}
                    Receipts will be provided as needed for your insurance
                    provider.
                  </p>
                </div>

                {/* Sliding scale note */}
                <div className="flex items-start gap-3 p-4 bg-white rounded-xl border border-sage/15 mb-8" data-id="element-782">
                  <DollarSign className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" data-id="element-783" />
                  <p className="text-sm text-teal/80" data-id="element-784">
                    <span className="font-medium text-teal" data-id="element-785">
                      Sliding scale available.
                    </span>{' '}
                    I believe therapy should be accessible. If cost is a
                    barrier, let's talk about it.
                  </p>
                </div>

                <Button size="lg" onClick={() => window.open(BOOKING_URL, '_blank')} data-id="element-786">
                  Book Free Consultation
                </Button>
              </div>

              <div className="bg-white p-8 rounded-2xl border border-sage/10" data-id="element-787">
                <h3 className="text-xl font-medium text-teal mb-6" data-id="element-788">
                  Specialisations
                </h3>
                <ul className="space-y-4" data-id="element-789">
                  {['Anxiety and OCD', 'Life transitions (career, relationships)', 'Breaking people-pleasing patterns', 'Navigating comparison culture', 'Authentic confidence building', 'Stress and burnout'].map((item, i) => <li key={i} className="flex items-center text-teal/80 p-3 bg-neutral-soft rounded-lg" data-id="element-790">
                      <ArrowRight className="w-4 h-4 text-terracotta mr-3" data-id="element-791" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>

          {/* Coming Soon Section */}
          <div className="text-center mb-12" data-id="element-792">
            <h2 className="text-2xl font-medium text-teal mb-4" data-id="element-793">Coming Soon</h2>
            <p className="text-teal/70" data-id="element-794">
              Expanding our support options to meet you where you are.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-795">
            {[{
            title: 'Group Therapy',
            desc: 'Connect with others navigating similar challenges in a facilitated, safe space.',
            icon: <Users className="w-6 h-6" data-id="element-796" />
          }, {
            title: 'Workshops',
            desc: 'Focused sessions on specific topics like boundaries, anxiety, and self-compassion.',
            icon: <Brain className="w-6 h-6" data-id="element-797" />
          }, {
            title: 'Online Courses',
            desc: 'Self-paced learning to support your mental health journey from anywhere.',
            icon: <BookOpen className="w-6 h-6" data-id="element-798" />
          }].map((item, i) => <div key={i} className="bg-white border border-neutral-200 p-8 rounded-2xl opacity-70 hover:opacity-100 transition-opacity" data-id="element-799">
                <div className="w-12 h-12 bg-neutral-100 rounded-full flex items-center justify-center mb-6 text-teal" data-id="element-800">
                  {item.icon}
                </div>
                <h3 className="text-xl font-medium text-teal mb-3" data-id="element-801">
                  {item.title}
                </h3>
                <p className="text-teal/70 text-sm mb-4" data-id="element-802">{item.desc}</p>
                <span className="inline-block px-3 py-1 bg-neutral-100 text-teal/60 text-xs font-medium rounded-full" data-id="element-803">
                  Coming Soon
                </span>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}